export default __webpack_public_path__ + "static/media/Tools-P9-CIFOR.9bbe1e98.jpg";